// removed by extract-text-webpack-plugin
module.exports = {"crown":"crown___2nOlG","crown-inner":"crown-inner___1Fiji"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/WhiteLabelCrown/WhiteLabelCrown.scss
// module id = a3vv
// module chunks = 57